import type { TemporalProfileRole } from '@streamlain/database-identity';

import { type DataViewI18nKey, dataViewI18nT } from '../core/i18n.js';

const TEMPORAL_PROFILE_STATIC_NAMES = {
  assignee: 'Assignee',
  dependencies: 'Dependencies',
  progress: 'Progress',
} as const;

export function defaultTemporalProfileColumnName(
  role: TemporalProfileRole
): string {
  if (role in TEMPORAL_PROFILE_STATIC_NAMES) {
    return TEMPORAL_PROFILE_STATIC_NAMES[
      role as keyof typeof TEMPORAL_PROFILE_STATIC_NAMES
    ];
  }
  return dataViewI18nT(`calendar.wizard.role.${role}.name` as DataViewI18nKey);
}
